var errorCallBack = function (result) {
    alert("上传失败")
  };

  var progressCallBack = function (curr) {};

  var taskReady = function (taskId) {};
  var widthSrc, heightSrc, imgSrc;

  export var livefileupload = function(axios, path, bucket, successCallback, fileCallback, beforeCallBack, checkCallBack) {
    this.path = path;
    this.success = successCallback;
    this.before = beforeCallBack;
    this.check = checkCallBack;
    var global = this;
    if (!bucket || bucket == '')
      bucket = process.env.cdn_bucket;
    this.bucket = bucket;
    this.fileCallback = fileCallback;
    axios.get(process.env.platform_url_prefix + "/auth/fileupload/getAppSign?bucket=" + bucket).then(function (res) {
      var backData = res.data;
      if (backData.status == 200) {
        var bucket1 = backData.data.bucket;
        var region = backData.data.region;
        var sign = backData.data.sign;
        global.cos = new CosCloud({
          appid: process.env.tencent_appid, // APPID 必填参数
          bucket: bucket1, //bucketName 必填参数
          region: region, //地域信息 必填参数 华南地区填gz 华东填sh 华北填tj
          getAppSign: function (callback) { //获取签名 必填参数
            callback(sign);
          },
          getAppSignOnce: function (callback) { //单次签名，必填参数，参考上面的注释即可
            callback(sign);
          }
        });
      } else {
        alert(backData.msg)
      }
    }).catch(function (err) {
      console.log(err);
    });

    function upload(inputFileId, compressFlag, compressConfig) {
      if (!inputFileId) {
        inputFileId = 'js_file'
      }
      if (!compressFlag) {
        compressFlag = false
      }
      if (!compressConfig) {
        compressConfig = {}
      }
      var global = this;
      var uploadFunction = function (e) {
        var file = e.target.files[0];
        if (global.check) {
          if(!global.check()) {
              $('#fileForm')[0].reset();
              return;
          }
        }
        if (global.before)
          global.before();
        if (global.fileCallback)
          global.fileCallback(file);
        if (compressFlag) {
          var info = imgInfo(file);
          var size_2M = 1024 * 1024 * 2;
          if (info.size > size_2M) {
            setTimeout(function () {
              //大于2M 就压缩
              var width = compressConfig.width ? compressConfig.width : 1000;
              var ratio = compressConfig.ratio ? compressConfig.ratio : 0.7;
              var height;
              if (compressConfig.height) {
                height = compressConfig.height
              } else {
                var wRation = width / widthSrc;
                if (wRation > 1) {
                  width = widthSrc
                  height = heightSrc
                } else {
                  height = heightSrc * wRation;
                }
              }
              var img64 = compress(imgSrc, width, height, ration);
              var newImg = convertBase64UrlToBlob(img64);
              global.cos.uploadFile(successCallback, errorCallBack,
                progressCallBack, global.bucket, global.path + new Date().getTime() + info.name, newImg,
                0, taskReady);
            }, 1000);
          } else {
            global.cos.uploadFile(successCallback, errorCallBack,
              progressCallBack, global.bucket, global.path + new Date().getTime() + file.name, file,
              0, taskReady);
          }
        } else {
          global.cos.uploadFile(successCallback, errorCallBack,
            progressCallBack, global.bucket, global.path + new Date().getTime() + file.name, file,
            0, taskReady);
        }
        $('#fileForm')[0].reset();
        return false;
      };
      //$('#'+inputFileId).off('change').on('change',);

      $('#' + inputFileId).unbind();
      $('#' + inputFileId).bind('change', uploadFunction);

      setTimeout(function () {
        $('#' + inputFileId).click();
      }, 0);
    };
    /**
     * 将以base64的图片url数据转换为Blob
     * @param urlData
     *            用url方式表示的base64图片数据
     */
    function convertBase64UrlToBlob(urlData) {
      var arr = urlData.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    };
    /*
     * 图片压缩
     * img    原始图片
     * width   压缩后的宽度
     * height  压缩后的高度
     * ratio   压缩比率
     */
    function compress(img, width, height, ratio) {
      var canvas, ctx, img64;

      canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      img64 = canvas.toDataURL("image/jpeg", ratio);

      return img64;
    };

    function imgInfo(file) {
      var result = {};
      var img = new Image;
      img.onload = function () {
        widthSrc = img.width;
        heightSrc = img.height;
      };
      img.src = window.URL.createObjectURL(file);
      var imgName = file.name;
      result.name = imgName;
      result.size = file.size;
      imgSrc = img;
      return result;
    };

    this.upload = upload;

  }

  export var livefiledelete = function(axios, bucket, successCallBack, errorCallBack, path) {
    if (!bucket || bucket == '')
    bucket = process.env.cdn_bucket;
    axios.get(process.env.platform_url_prefix + "/auth/fileupload/getAppSign?bucket=" + bucket).then(function (res) {
      var backData = res.data;
      if (backData.status == 200) {
        // debugger;
        var bucket1 = backData.data.bucket;
        var region = backData.data.region;
        var sign = backData.data.sign;
        var cos = new CosCloud({
          appid: process.env.tencent_appid, // APPID 必填参数
          bucket: bucket1, //bucketName 必填参数
          region: region, //地域信息 必填参数 华南地区填gz 华东填sh 华北填tj
          getAppSign: function (callback) { //获取签名 必填参数
            callback(sign);
          },
          getAppSignOnce: function (callback) { //单次签名，必填参数，参考上面的注释即可
            callback(sign);
          }
        });
        cos.deleteFile(successCallBack, errorCallBack, bucket, path);
      } else {
        alert(backData.msg)
      }
    }).catch(function (err) {
      console.log(err);
    });

  }


  export var imgFileUpload = function(axios, path, bucket, successCallback, checkCallBack) {
    this.path = path;
    this.success = successCallback;
    this.check = checkCallBack;
    var global = this;
    if (!bucket || bucket == '')
      bucket = process.env.cdn_bucket;
    this.bucket = bucket;
    axios.get(process.env.platform_url_prefix + "/auth/fileupload/getAppSign?bucket=" + bucket).then(function (res) {
      var backData = res.data;
      if (backData.status == 200) {
        var bucket1 = backData.data.bucket;
        var region = backData.data.region;
        var sign = backData.data.sign;
        global.cos = new CosCloud({
          appid: process.env.tencent_appid, // APPID 必填参数
          bucket: bucket1, //bucketName 必填参数
          region: region, //地域信息 必填参数 华南地区填gz 华东填sh 华北填tj
          getAppSign: function (callback) { //获取签名 必填参数
            callback(sign);
          },
          getAppSignOnce: function (callback) { //单次签名，必填参数，参考上面的注释即可
            callback(sign);
          }
        });
      } else {
        alert(backData.msg)
      }
    }).catch(function (err) {
      console.log(err);
    });

    function upload(inputFileId, compressFlag, compressConfig) {
      if (!inputFileId) {
        inputFileId = 'js_file'
      }

      var global = this;
      var uploadFunction = function (e) {
        var file = e.target.files[0];
        if (global.check) {

          //异步的
          global.check(file).then(flag=>{
            if(flag){
              global.cos.uploadFile(successCallback, errorCallBack,
                progressCallBack, global.bucket, global.path + new Date().getTime() + file.name, file,
                0, taskReady);
              $('#fileForm')[0].reset();
              return false;
            }else{
              $('#fileForm')[0].reset();
              return false;
            }
          }).catch(err=>{
            $('#fileForm')[0].reset();
            alert("img check error should be promise");
            return false;
          })
        }else{
          global.cos.uploadFile(successCallback, errorCallBack,
            progressCallBack, global.bucket, global.path + new Date().getTime() + file.name, file,
            0, taskReady);
          $('#fileForm')[0].reset();
          return false;
        }

      };
      //$('#'+inputFileId).off('change').on('change',);

      $('#' + inputFileId).unbind();
      $('#' + inputFileId).bind('change', uploadFunction);

      setTimeout(function () {
        $('#' + inputFileId).click();
      }, 0);
    };

    this.upload = upload;

  }

  export var fileListupload = function(axios, path, bucket, successCallback, fileCallback, beforeCallBack, checkCallBack) {
    this.path = path;
    var global = this;
    if (!bucket || bucket == '') bucket = process.env.cdn_bucket;
    this.bucket = bucket;
    axios.get(process.env.platform_url_prefix + "/auth/fileupload/getAppSign?bucket=" + bucket).then(function (res) {
      var backData = res.data;
      if (backData.status == 200) {
        var bucket1 = backData.data.bucket;
        var region = backData.data.region;
        var sign = backData.data.sign;
        global.cos = new CosCloud({
          appid: process.env.tencent_appid, // APPID 必填参数
          bucket: bucket1, //bucketName 必填参数
          region: region, //地域信息 必填参数 华南地区填gz 华东填sh 华北填tj
          getAppSign: function (callback) { //获取签名 必填参数
            callback(sign);
          },
          getAppSignOnce: function (callback) { //单次签名，必填参数，参考上面的注释即可
            callback(sign);
          }
        });
      } else {
        alert(backData.msg)
      }
    }).catch(function (err) {
      console.log(err);
    });

    function upload(file, compressFlag, compressConfig) {
      if (!compressFlag) {
        compressFlag = false
      }
      if (!compressConfig) {
        compressConfig = {}
      }
      var global = this;
      checkRealImg(file).then(imgResult=>{
          console.log("-----imgResult---",imgResult);
          if (checkCallBack) {
            if(!checkCallBack(file)) {
                $('#fileForm')[0].reset();
                return;
            }
          }
          if (beforeCallBack)  beforeCallBack();
          if (fileCallback) fileCallback(file);
          if (compressFlag) {
            var info = imgInfo(file);
            var size_2M = 1024 * 1024 * 2;
            if (info.size > size_2M) {
              setTimeout(function () {
                //大于2M 就压缩
                var width = compressConfig.width ? compressConfig.width : 1000;
                var ratio = compressConfig.ratio ? compressConfig.ratio : 0.7;
                var height;
                if (compressConfig.height) {
                  height = compressConfig.height
                } else {
                  var wRation = width / widthSrc;
                  if (wRation > 1) {
                    width = widthSrc
                    height = heightSrc
                  } else {
                    height = heightSrc * wRation;
                  }
                }
                var img64 = compress(imgSrc, width, height, ration);
                var newImg = convertBase64UrlToBlob(img64);
                global.cos.uploadFile(successCallback, errorCallBack, progressCallBack, global.bucket, global.path + new Date().getTime() + info.name, newImg, 0, taskReady);
              }, 1000);
            } else {
              global.cos.uploadFile(successCallback, errorCallBack, progressCallBack, global.bucket, global.path + new Date().getTime() + file.name, file, 0, taskReady);
            }
          } else {
            global.cos.uploadFile(successCallback, errorCallBack, progressCallBack, global.bucket, global.path + new Date().getTime() + file.name, file, 0, taskReady);
          }
          $('#fileForm')[0].reset();
      }).catch(err=>{
        alert(err);
        $('#fileForm')[0].reset();
      })
    };
    /**
     * 将以base64的图片url数据转换为Blob
     * @param urlData
     *            用url方式表示的base64图片数据
     */
    function convertBase64UrlToBlob(urlData) {
      var arr = urlData.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    };
    /*
     * 图片压缩
     * img    原始图片
     * width   压缩后的宽度
     * height  压缩后的高度
     * ratio   压缩比率
     */
    function compress(img, width, height, ratio) {
      var canvas, ctx, img64;

      canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      img64 = canvas.toDataURL("image/jpeg", ratio);

      return img64;
    };

    function imgInfo(file) {
      var result = {};
      var img = new Image;
      img.onload = function () {
        widthSrc = img.width;
        heightSrc = img.height;
      };
      img.src = window.URL.createObjectURL(file);
      var imgName = file.name;
      result.name = imgName;
      result.size = file.size;
      imgSrc = img;
      return result;
    };

    function checkRealImg(file){
      return new Promise((resolve,reject)=>{
        let img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onerror = function(){
          reject("错误的图片！");
        }
        img.onload = function(){
          var result = {width:img.width,height: img.height};
          resolve(result);
        }
      })
    };

    this.upload = upload;
  }



// WEBPACK FOOTER //
// ./src/assets/js/cosUtil.js